import React, { useContext, useEffect, useState } from "react";
import { useMediaQuery } from "beautiful-react-hooks";

import Slide from "./slide";
import Slider from "./slider";
import { Dots } from "./dots";
import SliderContext from "./context";
// import data from "./data";

import "./style.scss";
import { LanguageContext, text } from "../../container/language";
import Tags from "../Tags";
import { buildURLForArticle, buildURLForCategory } from "../../utils/buildURL";

export default function Presentation({ data }) {
  const { userLanguage } = useContext(LanguageContext);
  const [activeIndex, setActive] = useState(0);
  const [count, setCount] = useState(0);

  const mediaMobile = useMediaQuery(
    "(min-width: 320px) and (max-width: 768px)"
  );

  const mediaTablet = useMediaQuery(
    "(min-width: 769px) and (max-width: 1024px)"
  );

  useEffect(() => {
    window && window.dispatchEvent(new Event("resize"));
  }, []);

  // console.log("buildURLForArticle", buildURLForArticle(data[3].article));

  // {mobileScreen, desktopScreen: {formats: {large, medium, small, thumbnail}}, tags, title, collapsedTitle, description}
  return (
    <div className="presentation__wrap">
      <div
        className="presentation kwicks-horizontal kwicks-processed"
        data-expanded="1"
      >
        <SliderContext.Provider
          value={{ activeIndex, setActive, count, setCount }}
        >
          <Slider>
            {data.map((item) => (
              <Slide
                title={text(item.collapsedTitle || item.title, userLanguage)}
                more={"See all"}
                link={`${buildURLForArticle(item.article)}`}
                images={{
                  high: item.desktopScreen.url,
                  low: item.mobileScreen.url,
                }}
              >
                <Tags data={item.tags} />
                <div className="presentation__title">
                  {text(item.title, userLanguage)}
                </div>
                <ul
                  dangerouslySetInnerHTML={{
                    __html: text(item.description, userLanguage),
                  }}
                ></ul>
              </Slide>
            ))}
          </Slider>

          {(mediaMobile || mediaTablet) && <Dots />}
        </SliderContext.Provider>
      </div>

      <div className="presentation-loader">
        <img src="../../assets/images/loader.svg" alt="" />
      </div>
    </div>
  );
}
